import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('OpinionFactor/getAll');
    const { statusData } = useEntityCrud('OpinionFactor/ChangeStatus');
    const [rows, setRows] = useState([]);
    const [title,setTitle] = useState('');
    const [searched,setSearched] = useState(false);
    const [filteredRows,setFilteredRows] = useState([]);
    const [currentPage,setCurrentPage] = useState(1);
    const [pages,setPages] = useState(0);

    const calcPages = result => {
        let calcPages = result.length / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const getData = () => {
        readData().then(({ data }) => {
            if (data.status){
                setRows(data.result);
                calcPages(data.result);
                const result = [...data.result.slice(0,10)]
                setFilteredRows(result);
            }
        });
    }

    useEffect(() => {
        getData();
    }, [])

    const search = () => {
        let allRows = [...rows];
        if(title)
            allRows = allRows.filter(row => row.title.includes(title));
        setFilteredRows(allRows);
        calcPages(allRows);
        setSearched(true);
        setCurrentPage(1);
    }

    const clearSearch = () => {
        setTitle('');
        setFilteredRows([...rows.slice(0,10)]);
        calcPages(rows)
        setCurrentPage(1);
        setSearched(false);
    }

    const deActiveRow = (id, title) => {
         
        const postedData = {
            id,
            status: false,
            title: title
        };
        statusData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success(' معیار نظرسنجی مورد نظر با موفقیت غیرفعال  شد');
                getData();
            } else
                data.errors?.map(error => toast.error(error.message));
        });
    }

    const activeRow = (id, title) => {
         
        const postedData = {
            id,
            status: true,
            title: title
        };
        statusData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success(' معیار نظرسنجی مورد نظر با موفقیت فعال شد');
                getData();
            } else
                data.errors?.map(error => toast.error(error.message));
        });
    }

    const nextPage = () => {
        const skip = currentPage * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage + 1);
    }

    const prevPage = () => {
        const skip = (currentPage - 2) * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage - 1);
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">معیارهای نظرسنجی   </div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد معیار  </Link> : ''}
                <button className="btn btn-dark mx-2 accordion-toggle collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>
                <div className="panel-group1 mt-3" id="accordion1">
                    <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>عنوان</label>
                                    <input className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-4" style={{marginTop: 29}}>
                                <button className="btn btn-success me-2" onClick={search}>جستجو</button>
                                {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                {context.checkHasPermission('create') ? <hr /> : ''}
                {filteredRows.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRows.map((item, index) => (
                            <tr key={index}>
                                <td>{(currentPage - 1) * 10 + (index + 1)}</td>
                                <td>{item.title || '-'}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} title="ویرایش" className="btn btn-icon mb-0 btn-primary"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('delete') ? (item.status ? <button title="غیرفعال سازی" onClick={e => deActiveRow(item.id, item.title)} className="btn btn-icon mb-0 btn-danger"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id, item.title)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>) : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {rows.length}</p>
                {pages.length > 1 && <div className="text-center">
                    <button className="btn btn-primary me-2" disabled={currentPage == 1} onClick={prevPage}>قبلی</button>
                    <button className="btn btn-primary" disabled={currentPage == pages.length} onClick={nextPage}>بعدی</button>
                </div>}
                </div> : <div className="alert alert-info"><p>معیار نظرسنجی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;